import Big from 'big.js';
import * as models from 'smg/models';

type orderDisplayStatus =
    | 'Delivered'
    | 'On the Way'
    | 'In Production'
    | 'Awaiting Payment'
    | 'Unknown';

type orderStatusTag =
    | 'tag-success'
    | 'tag-danger'
    | 'tag-info'
    | 'tag-light'
    | 'tag-warning';

interface orderStatusResult {
    status: orderDisplayStatus;
    tag: orderStatusTag;
}

export function GetOrderStatus(order: models.Order): orderStatusResult {
    if (order.balance && Big(order.balance).gt(0.05)) {
        return {
            status: 'Awaiting Payment',
            tag: 'tag-danger',
        };
    }

    let hasShipments = false;
    let delivered = false;
    let partiallyDelivered = false;

    for (const shippingOption of order.orderShippingOptions ?? []) {
        for (const shipmentOption of shippingOption.orderShippingOptionShipments ?? []) {
            const shipment = shipmentOption.shipment;

            if (shipment) {
                hasShipments = true;
                if (shipment.delivered) {
                    delivered = true;
                } else {
                    partiallyDelivered = true;
                }
            }
        }
    }

    if (delivered && !partiallyDelivered) {
        return {
            status: 'Delivered',
            tag: 'tag-success',
        };
    }

    if (partiallyDelivered || hasShipments) {
        return {
            status: 'On the Way',
            tag: 'tag-light',
        };
    }

    if (order.orderStatusID === models.OrderStatusID.ORDER_STATUSES_CONFIRMED && order.shipmentsCount === 0) {
        return {
            status: 'In Production',
            tag: 'tag-info',
        };
    }

    return {
        status: 'Unknown',
        tag: 'tag-warning',
    };
}